// src/components/ui/GlobalLoader.js

import React from "react";
import { useSelector } from "react-redux";
import styles from "./globalLoader.module.css";

const GlobalLoader = () => {
  // Nos suscribimos a los estados de carga que consideramos críticos
  const isTenantLoading = useSelector((state) => state.tenant.loading);
  const isAuthLoading = useSelector((state) => state.auth.isLoading);

  // El loader se mostrará si CUALQUIERA de las operaciones críticas está en curso
  const isLoading = isTenantLoading || isAuthLoading;

  return (
    <div
      className={`${styles.loadingOverlay} ${!isLoading ? styles.hidden : ""}`}
    >
      <div className={styles.spinner}></div>
      <p className={styles.loadingText}>Cargando...</p>
    </div>
  );
};

export default GlobalLoader;
